export default {
  storageKey: 'p2s5u8x/A?D(G+KbPeShVmYq3t6w9y$B',
};
